import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="pt-20 pb-12 md:pt-24 md:pb-16 bg-bio-dark relative overflow-hidden" data-id="element-233">
      {/* Background radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-[600px] bg-bio-amber/5 rounded-full blur-[100px] pointer-events-none" data-id="element-234" />

      <div className="container mx-auto px-6 relative z-10 max-w-4xl text-center" data-id="element-235">
        <FadeIn data-id="element-236">
          <ShieldCheck className="w-16 h-16 text-bio-amber mx-auto mb-8 drop-shadow-[0_0_15px_rgba(245,166,35,0.4)]" data-id="element-237" />

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-238">
            SECURE YOUR BIOLOGICAL SOVEREIGNTY TODAY.
          </h2>

          <p className="text-xl text-bio-text font-light mb-6 max-w-2xl mx-auto" data-id="element-239">
            The full BioCorp Protocol, including the 72-Hour Rapid Response
            Manual and the Sovereignty Manual.
          </p>

          <div className="inline-block border border-bio-amber/30 bg-bio-black/50 backdrop-blur-sm p-8 mt-2 mb-8 relative" data-id="element-240">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-bio-amber" data-id="element-241" />
            <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-bio-amber" data-id="element-242" />
            <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-bio-amber" data-id="element-243" />
            <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-bio-amber" data-id="element-244" />

            <div className="font-mono text-bio-muted text-sm tracking-widest mb-2 uppercase" data-id="element-245">
              Total Private Investment
            </div>
            <div className="flex items-center justify-center gap-4 mb-1" data-id="element-246">
              <span className="font-mono text-xs tracking-widest text-bio-muted uppercase" data-id="element-247">
                Was
              </span>
              <span className="font-oswald text-2xl md:text-3xl font-bold text-bio-muted/70 line-through decoration-bio-amber/60 decoration-2" data-id="element-248">
                $97
              </span>
            </div>
            <div className="text-6xl md:text-7xl font-bold text-bio-amber text-glow-amber" data-id="element-249">
              $6.39
            </div>
            <div className="mt-3 inline-block px-3 py-1 border border-bio-teal/40 bg-bio-teal/5 font-mono text-[10px] tracking-widest text-bio-teal uppercase" data-id="element-250">
              93% Discount Active
            </div>
          </div>

          <div data-id="element-251">
            <Button className="w-full md:w-auto md:px-16 md:py-6 text-2xl" onClick={() => window.open('https://www.healingsomibo.com/cart/45880492589254:1', '_blank', 'noopener,noreferrer')} data-id="element-252">
              <span data-id="element-253">BUILD MY</span>
              <span data-id="element-254">FORTRESS NOW</span>
            </Button>
            <p className="mt-6 font-mono text-xs text-bio-muted tracking-widest" data-id="element-255">
              YOUR DIGITAL ACCESS WILL BE DELIVERED IMMEDIATELY TO YOUR SECURE
              INBOX.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}